<template>
  <div class="layout">
    <el-container style="height: 100%;">
      <el-header style="height: 60px">
        <el-row>
          <el-col :span="21">
            <router-link :to="{path:'/'}" class="href">
              <span class="logo">私人管家</span>
            </router-link>
          </el-col>
          <el-col :span="3">
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <img src class="photo" />
                {{ username }}
                <i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="is_bind <= 0">
                  <span style="display:block;" @click="showBindModal">
                    <i class="el-icon-connection"></i> 绑定微信
                  </span>
                </el-dropdown-item>
                <el-dropdown-item v-if="is_set <= 0">
                  <span style="display:block;" @click="getRsaKey">
                    <i class="el-icon-connection"></i> 设置密钥
                  </span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span style="display:block;" @click="logout">
                    <i class="el-icon-back"></i> 退出
                  </span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-header>
      <el-container style="height: 100%;">
        <el-aside width="200px">
          <div class="leftmenu">
            <el-aside width="200px">
              <el-scrollbar wrap-class="scrollbar-wrapper">
                <el-menu
                  :default-active="$route.path"
                  class="el-menu-vertical-demo"
                  background-color="#304156"
                  text-color="#BFCBD9"
                  active-text-color="#1890FF"
                  :router="true"
                >
                  <span v-for="(item, index) in menuList" :key="index">
                    <span v-if="item.children.length > 0">
                      <el-submenu :index="''+index">
                        <template slot="title">
                          <i :class="item.icon"></i>
                          <span>{{ item.menu_name }}</span>
                        </template>
                        <el-menu-item
                          v-for="(item2, index2) in item.children"
                          :key="index2"
                          :index="item2.url"
                        >{{ item2.menu_name }}</el-menu-item>
                      </el-submenu>
                    </span>
                    <span v-else>
                      <el-menu-item :index="item.url">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.menu_name }}</span>
                      </el-menu-item>
                    </span>
                  </span>
                </el-menu>
              </el-scrollbar>
            </el-aside>
          </div>
        </el-aside>
        <el-container>
          <el-main>
            <div class="box" v-loading="$store.state.loading">
              <router-view />
            </div>
          </el-main>
          <el-footer style="height:50px">您的私人管家(Lucifer)</el-footer>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      username: sessionStorage.getItem("username") || "",
      is_bind: sessionStorage.getItem('is_bind') || 0,
      is_set: sessionStorage.getItem('is_set') || 0,
      menuList: []
    };
  },
  methods: {
    logout() {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("username");
      sessionStorage.removeItem("type");
      sessionStorage.removeItem('is_set');
      this.$util.msg("退出成功", "success");
      setTimeout(() => {
        this.$router.replace({ path: "/login" });
      }, 1200);
    },
    getMenu() {
      this.$ajax({
        url: "/menu/index"
      }).then(data => {
        this.menuList = data.data;
      });
    },
    showBindModal() {
      this.$confirm([
        '<div style="text-align:center"><img width="360" src="/api/oauth/qrcode?token=', sessionStorage.getItem('token'),'"></div>',
        '<div style="text-align:center">请使用微信扫一扫</div>'
      ].join(''), '绑定微信', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      });
    },
    getRsaKey() {
      this.$ajax({
        url: '/admin/account',
      }).then(res => {
        if(res.code != 200) {
          return this.$message.error(res.msg);
        }

        return this.$alert([
          '<div style="width: 600px;"><div style="text-align:center"><div style="display:inline-block;vertical-align: top;">密钥:</div><div style="display:inline-block"><pre>', res.data.private_key, '</pre></div></div>',
          '<div style="text-align:center;color:red;">您的密钥设置成功，系统将不再保存您的密钥，请注意保存!!!</div></div>'
        ].join(''), '密钥设置', {
          dangerouslyUseHTMLString: true,
        });
      })
    },
  },
  created() {
    this.getMenu();
  }
};
</script>
<style>
.layout {
  width: 100%;
  height: 100%;
}
.logo {
  font-size: 22px;
  font-weight: bold;
  font-family: "SimSun";
  letter-spacing: 2px;
}
.content {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}
.leftmenu,
.el-aside {
  height: 100%;
  user-select: none;
  /* overflow: hidden; */
}
.el-scrollbar{
  height: 100%;
  position: relative;
}
.leftmenu .el-scrollbar::after{
  content: "";
  width: 100%;
  height: 17px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #304156;
}
.el-message-box{
  overflow: initial !important;
  width: auto !important;
}
.href span{
  color: #fff;
}
</style>